// removed by extract-text-webpack-plugin
module.exports = {"root":"PaymentList__root___mKc8K","item":"PaymentList__item___a2sPf","cell":"PaymentList__cell___3NjUF","label":"PaymentList__label___21zP_","value":"PaymentList__value___d9O6t"};